import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

/**
 * Footerコンポーネントを描画する
 * @component
 * @returns {JSX.Element}
 */
const Footer = () => {
  return (
    <footer className={styles.footer}>
      <Link to="/">
        <img src="../images/header_logo.png" alt="service logo" />
      </Link>
      <div className={styles.sytem_name}>測定監視システムEDMS</div>
      <div className={styles.space}></div> {/* スペース用 */}
    </footer>
  );
};

export default Footer;
